<ll-titulo>Evaluaciones Recomendadas</ll-titulo>
<ll-toolnavbar>
    <evaluacion-recomendadas-toolnavbar [displayButtons]="'new'"></evaluacion-recomendadas-toolnavbar>
</ll-toolnavbar>

<evaluaciones-recomendadas-list [showEvaluacionMultiple]="showEvaluacionMultiple"></evaluaciones-recomendadas-list>
